import script from "./collect.vue?vue&type=script&setup=true&lang=js"
export * from "./collect.vue?vue&type=script&setup=true&lang=js"

import "./collect.vue?vue&type=style&index=0&id=2e12a512&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e12a512"]])

export default __exports__